<template>
  <section class="self-mod">
    <p class="self-mod-desc">私服MOD正在研发中，敬请期待。</p>
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    // 私服MOD
    name: 'selfMod'
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "selfMod.styl";
</style>



// WEBPACK FOOTER //
// src/views/selfMod/selfMod.vue